<template>
  <div class="ab_street_header">
    <div class="ab_street_header_title">
      <div class="ab_street_title">
        <span>
          {{ spot.street }}
        </span>
      </div>
      <div class="ab_street_sub">
        <div
          v-if="hasSolvedLine"
          v-html="
            $t(`analyze.hand.solved_for_html`, {
              depth: spot.live_solved_depth
                ? numFixedUnit(spot.live_solved_depth, 'bb')
                : spot.solved_stacks
                ? spot.solved_stacks.map(i => numRoundTo5bb(Number(i))).join(', ')
                : numRoundTo5bb(spot.solved_depth),
            })
          "
        ></div>
        <div class="text-nowrap">
          {{ activePlayers || spot.players.filter(i => !i.is_folded).length }}
          {{ $t('analyze.hand.players') }},
          <span
            v-if="spot.live_solved_depth"
            class="live-solved-real-pot"
          >
            {{ numFixedUnit(spot.real_start_pot, 'bb') }} BB
          </span>
          <span v-else>
            {{ numFixedUnit(spot.start_pot, 'bb') }} BB
            <span
              v-if="hasReal && spot.real_start_pot !== spot.start_pot"
              class="real-pot"
              >({{ numFixedUnit(spot.real_start_pot, 'bb') }})</span
            >
          </span>
        </div>
      </div>
    </div>
    <CardRow
      :hasAnimation="false"
      class="ab_street_cards card-row_card_distant"
      size="small"
      cardStyle="--height: 2.5rem"
      :cards="board || spot.board"
    />
    <slot />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import CardRow from '@/components/CardRow/CardRow'

export default {
  name: 'HaStreetTitle',

  components: {
    CardRow,
  },
  mixins: [format_mix],
  props: {
    spot: Object,
    board: String,
    activePlayers: [Number, String],
    hasReal: Boolean,
    hasSolvedLine: Boolean,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.ab {
  &_street {
    background-color: var(--ha-street-background);
    &_header {
      margin: var(--ha-street-margin);
      display: flex;
      align-items: center;
      min-width: 100%;
      &_title {
        width: 9.5rem;
        display: flex;
        flex-direction: column;
        color: var(--clr-white-0);
      }
    }
    &_title {
      font-size: var(--ha-street-size);
      font-weight: var(--ha-street-weight);
      text-transform: uppercase;
    }
    &_cards {
      position: relative;
    }
    &_sub {
      color: var(--clr-grey-2);
      font-size: var(--ha-street-sub-size);
      font-weight: var(--ha-street-sub-weight);
      &_part {
        padding: 0 0.5rem 0 0;
      }
    }
  }
}
</style>
